import { TQLGraphResponse } from '@/entities/srm/tql-query';
import type { GraphUpdate } from '@/shared/ui/graph-renderer/contract';
import { TQLFilter } from '@/entities/srm/tql-query';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface SRMViewState {
  currentTQLQuery: string;
  setCurrentTQLQuery: (val: string) => void;
  isTQLEditorOpen: boolean;
  setIsTQLEditorOpen: (val: boolean) => void;
  isSavedTQLQueriesListOpen: boolean;
  setIsSavedTQLQueriesListOpen: (val: boolean) => void;
  filter: TQLFilter;
  setFilter: (val: TQLFilter) => void;
  graphData: TQLGraphResponse;
  graphUpdate?: GraphUpdate;
  setGraphData: (
    val: TQLGraphResponse | ((prev: TQLGraphResponse) => TQLGraphResponse),
    update?: GraphUpdate,
  ) => void;
  rawGraphData: TQLGraphResponse;
  setRawGraphData: (
    val: TQLGraphResponse | ((prev: TQLGraphResponse) => TQLGraphResponse),
  ) => void;
}

export const useSRMViewStore = create<SRMViewState>()((set) => ({
  filter: null,
  setFilter: (val) => set({ filter: val }),
  rawGraphData: null,
  setRawGraphData: (val) =>
    set((state) => ({
      rawGraphData: typeof val === 'function' ? val(state.rawGraphData) : val,
    })),
  graphData: null,
  setGraphData: (val, update) =>
    set((state) => ({
      graphData: typeof val === 'function' ? val(state.graphData) : val,
      graphUpdate: update
        ? {
            ...update,
            // A batched append must not lose pending deletions/attribute edits.
            type:
              state.graphUpdate?.type === 'reconcile'
                ? 'reconcile'
                : update.type,
            positions: { ...state.graphUpdate?.positions, ...update.positions },
          }
        : undefined,
    })),
  currentTQLQuery: '',
  setCurrentTQLQuery: (val) => set({ currentTQLQuery: val }),
  isTQLEditorOpen: false,
  setIsTQLEditorOpen: (val) => set({ isTQLEditorOpen: val }),
  isSavedTQLQueriesListOpen: false,
  setIsSavedTQLQueriesListOpen: (val) =>
    set({ isSavedTQLQueriesListOpen: val }),
}));